import bsCustomFileInput from 'bs-custom-file-input';

import textTruncate from './modules/_textTruncateModule/_text-truncate.js';

// Add array.where implementation
Array.prototype.where = Array.prototype.where || function (predicate) {
    var results = [], i, l, item;

    for (i = 0, l = this.length; i < l; i++) {
        item = this[i];
        if (predicate(item)) {
            results.push(item);
        }
    }
    return results;
};

Object.size = function (obj) {
    var size = 0, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
};

var _s,
    uscCore = {

        // define the required bits and pieces
        settings: {
            $window: $(window),
            $body: $('body'),
            $footer: $('#footer'),

            windowWidth: $(window).width(),

            dropdownItems: $('uib-accordion-group').map((i, v) => v.id),
            tabItems: $('.nav > a').map((i, v) => v.href),
        },

        // fire it up
        init: function () {
            _s = this.settings;
            this.bindUIActions();
            this.setMainMenu();

            _s.$body.removeClass('preload');

            $('[data-toggle="tooltip"]').tooltip();

            uscCore.checkHash();
            uscCore.protectImages();
        },

        setMainMenu: () => {
            /**
             * set the correct nav location based on screen size
             * */
            const onResizeEnd = () => {
                const w = window.innerWidth;
                const target = document.querySelector(`[data-nav="${w >= 1200 ? 'large' : 'small'}"]`);
                target.prepend(mainmenu);

                bindMenuHandlers(w);
            }

            let resizeTimer;
            window.onresize = () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(onResizeEnd, 100);
            };

            const menus = Array.from(header.querySelectorAll('.mega-menu'));
            const removeOpenFromMegaMenu = () => {
                menus.forEach(m => m.classList.remove('open'));
                rootMenuListItems.forEach(x => x.classList.remove('open'));
            };

            // these don't need to be removed when the menu moves as the element is hidden
            Array.from(document.querySelectorAll('.root-menu-list--touch-trigger')).forEach(elm => {
                elm.addEventListener('click', _ => {
                    elm.classList.toggle('open');
                    elm.closest('.root-menu-list--item').querySelector('.mega-menu').classList.toggle('open');
                });
            });

            const rootMenuListItems = Array.from(document.querySelectorAll('.root-menu-list--item'));
            const rootMenuListItemMouseEnter = evt => {
                removeOpenFromMegaMenu();

                const li = evt.target.closest('.root-menu-list--item');

                // calc offset for chevron - absolute position is relative to the list, not the list item
                // as the menu element needs to be relative to the menu, so all child absolute elements 
                // are relative to the same common non-static ancestor. boo.
                const offset = li.offsetLeft + (li.offsetWidth / 2) + 'px';
                li.style.setProperty('--chevron-offset', offset);

                li.classList.add('open');
                li.querySelector('.mega-menu').classList.add('open');
            };

            const headerMain = document.querySelector('.header-main');
            const headerMainMouseLeave = _ => removeOpenFromMegaMenu();

            let last = 0;
            const bindMenuHandlers = w => {
                if (w >= 1200 && last < 1200) {
                    rootMenuListItems.forEach(elm => elm.addEventListener('mouseenter', rootMenuListItemMouseEnter));
                    headerMain.addEventListener('mouseleave', headerMainMouseLeave);
                    document.body.classList.remove('overlay-in', 'overlay-in--menu');
                } else if (w < 1200 && (last >= 1200 || last === 0)) {
                    headerMain.removeEventListener('mouseleave', headerMainMouseLeave);
                    rootMenuListItems.forEach(elm => elm.removeEventListener('mouseenter', rootMenuListItemMouseEnter));
                }

                last = w;
            }

            // trigger menus
            onResizeEnd();
        },

        // wire up all the interface interactions
        bindUIActions: function () {

            bsCustomFileInput.init();

            textTruncate.init();

            _s.$window.on('hashchange', () => uscCore.checkHash());

            $('#access-links, #access-links a')
                .on('focus', () => $('#access-links').addClass('focus'))
                .on('focusout', () => $('#access-links').removeClass('focus'));

            // on ESC key press, close the active overlay if one exists
            document.addEventListener('keyup', e => {
                if (e.keyCode === 27 && document.body.classList.contains('overlay-in')) {
                    if (+document.body.dataset.activeMenu !== 0) {
                        let btn = document.querySelector('[submenu-button][data-index="' + document.body.dataset.activeMenu + '"]');
                        btn.click();
                        btn.focus();
                    } else {
                        document.querySelector('[overlay-button].active-link').click();
                    }
                }
            });

            $('a[data-toggle="tab"], a[data-toggle="pill"]').on('click', function () {
                history.pushState(null, null, $(this).attr('href'));
            });

            $(document)
                .on('focus', 'select, input, textarea', () => _s.$body.addClass('input-focus'))
                .on('blur', 'select, input, textarea', () => _s.$body.removeClass('input-focus'));

            $('#access-links').on('click', 'a', e => {
                var target = e.target.hash.replace('#', '');
                var el = document.getElementById(target);
                if (!/^(?:a|select|input|button|textarea)$/i.test(el.tagName)) {
                    el.tabIndex = -1;
                }

                $(el).on('focusout', () => $(el).tabIndex = 0);
                el.focus();
            });

            $(document).keyup(e => {
                if (e.keyCode === 27) {
                    document.activeElement.blur();
                }
            });
        },

        // examine location.hash and open dropdowns or toggle tabs as appropriate
        checkHash: function () {
            var h = location.hash.replace('#', '');
            if (!h) return;

            if (h === 'menu') {
                setTimeout(() => document.getElementById('menuButton').click());
            }
            else if (h === 'search') {
                setTimeout(() => document.getElementById('searchButton').click());
            }
            else {
                // track two different tab implementations - former from [tab] latter from multi-content component WITHOUT safe id set
                const tab = document.querySelector(`[href*="#tab-${h}"]`) || document.querySelector(`[data-toggle][href*="#${h}"]`);
                if (tab) {
                    $(tab).tab('show');
                    tab.scrollIntoView({ behavior: 'smooth' });
                    return;
                }

                const dropdown = document.querySelector(`[uib-accordion-group][id*="${h}"]`);
                if (dropdown) {
                    dropdown.querySelector('button').click();
                    dropdown.scrollIntoView({ behavior: 'smooth' });
                }
            }
        },

        /**
         * Make it a little harder for people to save images
         * Obviously not a foolproof solution, but just an extra hurdle to limit image reuse
         */
        protectImages: () => {
            for (var img of document.querySelectorAll('img')) {
                img.oncontextmenu = () => false;
            }
        }
    };


$(document).ready(() => uscCore.init());
